import { refs, throttle } from '../modules/utils.js';

class TopBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-on-top'];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve, 0));

    if (!this.moved) {
      this.refs = refs(this);
      this.#listeners();
      this.#scrollHandle();
    }

    setTimeout(() => this.setAttribute('data-active', ''), 1);
  }

  #listeners() {
  }

  #scrollHandle() {
    let y = window.scrollY;

    const scrollTest = function () {
      const currentY = window.scrollY;

      if (currentY <= 0) {
        this.setAttribute('data-on-top', '');
      }
      else {
        this.removeAttribute('data-on-top');
      }

      if (currentY > y) {
        this.dataset.scrollDirection = 'down';
      }
      else if (currentY < y) {
        this.dataset.scrollDirection = 'up';
      }

      y = currentY;
    }.bind(this);

    // immediate call
    scrollTest();
    setTimeout(scrollTest, 1000);

    window.addEventListener('scroll', throttle(scrollTest, 50));
  }
}

customElements.define('top-bar', TopBar);
